module.exports = __webpack_public_path__ + "img/landing-banner-2-mobile@2x.26be6cad.jpg";